import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type DetailsState } from './state'

export const useDetailsStore = defineStore('details', {
  state: useState,
  actions: { ...Actions },
  getters: { ...Getters },
})

export type DetailsStoreContext = ReturnType<typeof useDetailsStore>

export * from './cabin'
export * from './cruise'
export * from './flex-flight'
export * from './flight'
export * from './price'
export * from './rail'

